let dsBaseSize;

export function dsResizedEvent(t) {
    const event=new CustomEvent('resized');
    let timer=null;
    window.addEventListener('resize', function(){
        clearTimeout(timer);
        timer=setTimeout(function(){
            window.dispatchEvent(event);
        }, t);
    });
}

export function dsSetBaseSize() {
    let h=window.innerHeight*1;
    let w=window.innerWidth*0.75;
    dsBaseSize=(h>w)? w*0.01 : h*0.01;
    document.documentElement.style.setProperty('--vh', dsBaseSize+'px');
}

export function dsLoaded(t){
    dsSetBaseSize();
    setTimeout(function(){
        document.querySelector('body').classList.remove('loading');
    }, t);
}

export function dsOpenModal(target){
    const modal=document.querySelector(target).content.cloneNode(true);
    document.querySelector('#page').appendChild(modal);
    target=target.replace('#', '.');
    setTimeout(function(){
        document.querySelector(target).classList.add('modal_open');
    }, 100);
}
export function dsCloseModal(){
    const modal=document.querySelector('#page .modal_layer');
    modal.classList.remove('modal_open');
}
/*
function dsSwapModal(target){
    const before_modal=document.querySelector('#page .modal_layer');
    before_modal.classList.remove('modal_open');
    const modal=document.querySelector(target).content.cloneNode(true);
    document.querySelector('#page').appendChild(modal);
    target=target.replace('#', '.');
    setTimeout(function(){
        before_modal.remove();
    }, 600);
    setTimeout(function(){
        document.querySelector(target).classList.add('modal_open');
    }, 300);
}
*/
function dsSwapModal(target){
    dsCloseModal();
    setTimeout(function(){
        dsOpenModal(target);
    }, 200);
}

function dsHasValue(target){
    if(document.querySelector(target).value){
        return true;
    }else{
        return false;
    }
}

function dsHasValues(target, n){
    const elements=document.querySelectorAll(target);
    let flag=0;
    elements.forEach(function(element){
        if(element.value){
            flag++;
        }
    });
    if(flag>n-1){
        return true;
    }else{
        return false;
    }
}

function dsAddClass(target, class_name){
    document.querySelector(target).classList.add(class_name);
}

function dsRemoveClass(target, class_name){
    document.querySelector(target).classList.remove(class_name);
}

function dsToggleClass(target, class_name){
    document.querySelector(target).classList.toggle(class_name);
}

export function dsSelectBox(target){
    const elements=document.querySelectorAll(target);
    const body=document.querySelector('body');
    elements.forEach(function(element){
        const dt=element.querySelector('dt');
        const dd=element.querySelector('dd');
        const input=element.querySelector('[type="hidden"]');
        dt.addEventListener('click', function(event){
            dd.classList.add('open');
            body.classList.add('selecting');
            event.stopPropagation();
            body.onclick=function(){
                dd.classList.remove('open');
                body.classList.remove('selecting');
            }
        });
        const labels=element.querySelectorAll('label');
        labels.forEach(function(label){
            label.addEventListener('click', function(){
                element.querySelector('.selected').classList.remove('selected');
                this.classList.add('selected');
                dt.innerHTML=this.innerHTML;
                dd.classList.remove('open');
                body.classList.remove('selecting');
            });
        });
    });
}

function dsTabMenu(target){
    const container=document.querySelector(target);
    const elements=document.querySelectorAll(target+' a');
    elements.forEach(function(element){
        element.onclick=function(){
            const current=container.querySelector('.current');//****
            current.classList.remove('current');
            const id=current.getAttribute('href');
            console.log(document.getElementById(current.getAttribute('href').replace('#', '')));
            document.getElementById(current.getAttribute('href').replace('#', '')).classList.remove('open');
            this.classList.add('current');
            document.getElementById(this.getAttribute('href').replace('#', '')).classList.add('open');
            return false;
        }
    });
}

function dsBarGraph(target){
    const elements=document.querySelectorAll(target+' li');
    elements.forEach(function(element){
        const bar=element.querySelector('[data-point]');
        bar.innerHTML='<i style="width: '+bar.dataset.point+'"></i>';
    });
}

let funcCreateChart = null
export function dsRadarChart(target){
    const container=document.querySelector(target);
    const elements=document.querySelectorAll(target+' li:not(.canvas)');
    const n=elements.length;
    const angle=(Math.PI*2)/n;
    let point, r, position, x, y;
    removeCreateChart()
    funcCreateChart = function() {
        const scale=1.24;
        let cx=13.46*scale*dsBaseSize;
        let cy=14.3*scale*dsBaseSize;
        let a='';
        container.querySelector('.canvas').innerHTML='<svg><path class="rader_cart-path" /></svg>';
        elements.forEach(function(element, i){
            const pin=element.querySelector('span');
            point=pin.dataset.point;
            if(point==0){
                r=0;
                pin.innerHTML=''
            }
            if(point==1){
                r=3.6*scale*dsBaseSize;
                pin.innerHTML='<img src="images/analysis_report/pn-1.png" alt="" />'
            }
            if(point==2){
                r=8*scale*dsBaseSize;
                pin.innerHTML='<img src="images/analysis_report/pn-1.png" alt="" />'
            }
            if(point==3){
                r=12.3*scale*dsBaseSize;
                pin.innerHTML='<img src="images/analysis_report/pn-3.png" alt="" />'
            }
            x=cx+Math.sin(angle*i)*r;
            y=cy-Math.cos(angle*i)*r;
            position=x+','+y;
            pin.style.top=y+'px';
            pin.style.left=x+'px';
            if(i==0){
                a='M '+position;
            }else{
                a+=' L '+position;
            }
        });
        a+=' Z';
        const path=document.querySelector('.rader_cart-path');
        if (path) {
          path.setAttribute('d', a);
          path.setAttribute('fill', 'rgb(255,246,69,0.7)');
          path.setAttribute('stroke', '#684B0E');
        }
    }
    funcCreateChart();
    window.addEventListener('resized', funcCreateChart);
}

export function removeCreateChart() {
  if (funcCreateChart) {
    window.removeEventListener('resized', funcCreateChart)
    funcCreateChart = null
  }
}

function dsPencase(target){
    const elem=document.querySelector(target);
    const container=document.querySelector('#page');
    let active;
    function clearAactiveClass(){
        if(active=elem.querySelector('button.active')){
            active.classList.remove('active');
        }
    }
    elem.querySelector('dt').addEventListener('click', function(){
        if(elem.classList.contains('open')){
            elem.classList.remove('open');
            clearAactiveClass();
            container.classList.remove('learning');
        }else{
            container.classList.add('learning');
            elem.classList.add('open');
        }
    });
    const tools=elem.querySelectorAll('button:not(.close)');
    tools.forEach(function(tool){
        let active;
        tool.addEventListener('click', function(){
            clearAactiveClass();
            tool.classList.add('active');
        });
    });
    elem.querySelector('button.close').onclick=function(){
        clearAactiveClass();
        dsRemoveClass('.pencase', 'open');
        container.classList.remove('learning');
    }
}

function noScroll(event) {
    event.preventDefault();
}

export function dsNoBounceScroll() {
  document.addEventListener('touchmove', noScroll, { passive: false });
}

export function removeDsNoBounceScroll() {
  document.removeEventListener('touchmove', noScroll, { passive: false })
}

/**
 * 画面リサイズに関する初期化イベント。
 * 画面ごとではなく、アプリロード時に一度だけ呼び出す。
 */
export function initializeDisplaySize() {
  dsResizedEvent(300)
  window.addEventListener('resized', function () {
    dsSetBaseSize()
  })
}

function onScrollPageToTop() {
  const pxChange = 100
  const elm = document.getElementById('pageToTop')
  if (elm) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    if (scrollTop > pxChange) {
      elm.classList.add('fadein')
    } else {
      elm.classList.remove('fadein')
    }
  }
}

export function addPageToTopEvent() {
  window.addEventListener('scroll', onScrollPageToTop)
}

export function removePageToTopEvent() {
  window.removeEventListener('scroll', onScrollPageToTop)
}

